import React from 'react';
import { scrollToY } from '../utils/animated-scroll';
import arrowDown from '../assets/images/arrow-down.png';
import './scroll-button.scss';

export default class ScrollButton extends React.Component {
  onClick() {
    const mainContent = document.querySelector('.main');
    scrollToY(mainContent.offsetTop, 1500, 'easeOutSine');
  }

  render() {
    return (
      <div className="scroll-button" onClick={this.onClick}>
        <img src={arrowDown} width="50%" height="50%" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/scroll-button.js